export default "__VITE_ASSET__DZLswCEc__"